/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from 'Components/Lib/Utils/URLs.API';
import { useSearchParams } from 'react-router-dom';
import { formatDate, formatedToInput } from '../../../Helpers/dateHelper';
import ReactSelect from './ReactSelect';
import MFXLocalStorage from 'Helpers/MFXLocalStorage';

const Profiling = props => {
    const [defaultProfiling, setDefaultProfiling] = useState();
    const [searchParams] = useSearchParams();
    const [firstLoad, setFirstLoad] = useState(false);
    const [dropdowns, setDropDowns] = useState({});
    const [projectNumber, setProjectNumber] = useState(
        window.location.href
            ?.split('?')[1]
            ?.split('&')
            .filter(p => p.includes('project='))?.[0]
            ?.split('=')[1] ?? null
    );
    const [customerNumber, setCustomerNumber] = useState(
        MFXLocalStorage?.getTabData()?.primaryId > 0
            ? MFXLocalStorage?.getTabData()?.primaryId?.toString()
            : window.location.href
                  ?.split('?')[1]
                  ?.split('&')
                  .filter(p => p.includes('customer='))?.[0]
                  ?.split('=')[1]
    );
    const [index, setIndex] = useState(
        window.location.href
            ?.split('?')[1]
            ?.split('&')
            .filter(p => p.includes('index='))?.[0]
            ?.split('=')[1] ?? null
    );
    const [processNumber, setProcessNumber] = useState(
        window.location.href
            ?.split('?')[1]
            ?.split('&')
            .filter(p => p.includes('process='))?.[0]
            ?.split('=')[1] ?? null
    );
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (firstLoad) loadData();
    }, [props?.customData?.Assignment, props?.customData?.Category, props?.customData?.ProjectStatus]);
    
    function loadData() {
        if (props.designData.Type === 'Customer') {
            loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetProfilingCriterionsFilled + 'Customer' + (customerNumber && props.viewName !== 'addView' ? '&Data.DocumentIdentifier=' + customerNumber : '')).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDefaultProfiling(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
                    if (props.profilingLoaded) props.profilingLoaded(true, props.detailId);
                }
            });
        } else if (props.designData.Type === 'Contact') {
            loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetProfilingCriterionsFilled + 'ContactPerson' + (index && props.viewName !== 'addView' ? '&Data.DocumentIdentifier=' + index : '')).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDefaultProfiling(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
                    if (props.profilingLoaded) props.profilingLoaded(true, props.detailId);
                }
            });
        } else if (props.designData.Type === 'Project') {
            loadJsonData(
                '/' +
                    LocalStorage?.getConnectionKey() +
                    URLS.GetProfilingCriterionsFilled +
                    'Project' +
                    (projectNumber && props.viewName !== 'addView' ? '&Data.DocumentIdentifier=' + projectNumber : '') +
                    (props.customData?.ProjectStatus ? '&Data.DocumentRestrictionSelection=' + props.customData?.ProjectStatus : '')
            ).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDefaultProfiling(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
                    if (props.profilingLoaded) props.profilingLoaded(true, props.detailId);
                    setFirstLoad(true);
                }
            });
        } else if (props.designData.Type === 'Task') {
            loadJsonData(
                '/' + LocalStorage?.getConnectionKey() + URLS.GetProfilingCriterionsFilled + 'CrmTask' + (index && props.viewName !== 'addView' ? '&Data.DocumentIdentifier=' + index : '') + (props?.customData?.Category ? '&Data.DocumentRestrictionSelection=' + props?.customData?.Category : '')
            ).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDefaultProfiling(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
                    if (props.profilingLoaded) props.profilingLoaded(true, props.detailId);
                    setFirstLoad(true);
                }
            });
        } else if (props.designData.Type === 'Lead') {
            loadJsonData(
                '/' +
                    LocalStorage?.getConnectionKey() +
                    URLS.GetProfilingCriterionsFilled +
                    'CrmProcess' +
                    (index && props.viewName !== 'addView' ? '&Data.DocumentIdentifier=' + index : '') +
                    (props?.customData?.Assignment ? '&Data.DocumentRestrictionSelection=' + props?.customData?.Assignment : '')
            ).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDefaultProfiling(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
                    if (props.profilingLoaded) props.profilingLoaded(true, props.detailId);
                    setFirstLoad(true);
                }
            });
        }
        else {
            loadJsonData(
                '/' +
                    LocalStorage?.getConnectionKey() +
                    URLS.GetProfilingCriterionsFilled +
                    'CrmProcess' +
                    (processNumber && props.viewName !== 'addView' ? '&Data.DocumentIdentifier=' + processNumber : '') +
                    (props?.customData?.Assignment ? '&Data.DocumentRestrictionSelection=' + props?.customData?.Assignment : '')
            ).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDefaultProfiling(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
                    if (props.profilingLoaded) props.profilingLoaded(true, props.detailId);
                    setFirstLoad(true);
                }
            });
        }
    }

    function mergeUnique(arr1, arr2) {
        return arr1.concat(arr2.filter(item2 => !arr1.some(item1 => item1.CriterionKey === item2.CriterionKey)));
    }

    function onChange(inx, newValue) {
        var newData = JSON.parse(JSON.stringify(defaultProfiling));
        if (newData[inx]) newData[inx].Values = newValue;
        setDefaultProfiling(newData);
        console.log(newData);
        props.onChangeHandler({ newValue: newData, designData: props.designData });
    }
    return (
        <>
            {defaultProfiling &&
                defaultProfiling?.map((p, inx) => {
                    var mandatory = p.IsMandatory || (props.viewName === 'addView' && p.IsMandatoryNew);
                    console.log(p);
                    return (
                        <>
                            <div className="mfx-input-element">
                                {p.Type !== 3 && (
                                    <label style={{ paddingLeft: '3px', color: props.disableMode || Boolean(props.designData.ReadOnly) ? 'var(--gray)' : 'var(--fontColor)' }}>
                                        {p.Name + (mandatory ? '*' : '') }
                                    </label>
                                )}
                                {(p.Type === 0 || p.Type === 1 || p.Type === 4) && p.Conformity && !p.Multivalues && (
                                    <div className={`mfx-dropdown required-${mandatory}`}>
                                        <div className="mfx-react-select">
                                            <ReactSelect
                                                maxMenuHeight={150}
                                                id={p.Criteria}
                                                name={props.designData.Key}
                                                onChange={e => onChange(inx, [{ Index: p.Values[0]?.Index, Value: e.value, DisplayValue: e.label }])}
                                                options={p.DefaultValues?.map(option => {
                                                    return { label: option.Name, value: option.Value };
                                                })}
                                                //defaultValue={props.customerData ? {label: props.customerData, value: props.customerData} : defaultData}
                                                defaultValue={{ label: p.Values[0]?.DisplayValue, value: p.Values[0]?.Value }}
                                                isDisabled={props.disableMode || Boolean(props.designData.ReadOnly)}
                                            />
                                        </div>
                                    </div>
                                )}
                                {(p.Type === 0 || p.Type === 1 || p.Type === 4) && p.Conformity && p.Multivalues && !(props.disableMode || Boolean(props.designData.ReadOnly)) && (
                                    <div className={`mfx-dropdown required-${mandatory}`}>
                                        <div className="mfx-react-select">
                                            <ReactSelect
                                                maxMenuHeight={150}
                                                id={p.Criteria}
                                                name={props.designData.Key}
                                                required={mandatory}
                                                onChange={e => {
                                                    onChange(
                                                        inx,
                                                        e.map(v => {
                                                            return {
                                                                Index: p.Values.find(f => f.Value === v.value)?.Index,
                                                                Value: v.value,
                                                                DisplayValue: v.label,
                                                            };
                                                        })
                                                    );
                                                }}
                                                options={p.DefaultValues?.map(option => {
                                                    return { label: option.Name, value: option.Value };
                                                })}
                                                isMulti={true}
                                                //defaultValue={props.customerData ? {label: props.customerData, value: props.customerData} : defaultData}
                                                defaultValue={
                                                    p.Values?.map(v => {
                                                        return { label: v.DisplayValue, value: v.Value };
                                                    }) || []
                                                }
                                                isDisabled={props.disableMode || Boolean(props.designData.ReadOnly)}
                                            />
                                        </div>
                                    </div>
                                )}
                                {(p.Type === 0 || p.Type === 4) && p.Conformity && p.Multivalues && (props.disableMode || Boolean(props.designData.ReadOnly)) && (
                                    <div className="mfx-multivalues">
                                        {p.Values?.map(v => {
                                            return <span>{v.DisplayValue}</span>;
                                        })}
                                        {p.Values?.length === 0 && <span></span>}
                                    </div>
                                )}
                                {(p.Type === 0 || p.Type === 4 || p.Type === undefined || p.Type === null) && !p.Conformity && (
                                    <>
                                        <input required={mandatory} type="text" list={'options' + p.Criteria} defaultValue={p.Values[0]?.Value} disabled={props.disableMode} onChange={e => onChange(inx, [{ Index: p.Values[0]?.Index, Value: e.target.value, DisplayValue: e.target.value }])} />
                                        <datalist id={'options' + p.Criteria}>
                                            {p.DefaultValues?.map(d => {
                                                return <option>{d?.Value}</option>;
                                            })}
                                        </datalist>
                                    </>
                                )}
                                {p.Type === 1 && (
                                    <>
                                        <input
                                            required={mandatory}
                                            type="number"
                                            list={'options' + p.Criteria}
                                            defaultValue={isNaN(p.Values[0]?.Value?.replace(',', '.')) ? null : p.Values[0]?.Value?.replace(',', '.')}
                                            disabled={props.disableMode}
                                            onChange={e => onChange(inx, [{ Index: p.Values[0]?.Index, Value: e.target.value, DisplayValue: e.target.value }])}
                                        />
                                        <datalist id={'options' + p.Criteria}>
                                            {p.DefaultValues?.map(d => {
                                                return <option>{d?.Value}</option>;
                                            })}
                                        </datalist>
                                    </>
                                )}
                                {p.Type === 2 && (
                                    <input
                                        required={mandatory}
                                        type="date"
                                        defaultValue={formatedToInput(p.Values[0]?.Value,'Date')}
                                        disabled={props.disableMode}
                                        onChange={e => onChange(inx, [{ Index: p.Values[0]?.Index, Value: formatDate(new Date(e.target.value),'Date'), DisplayValue: formatDate(new Date(e.target.value),'Date') }])}
                                    />
                                )}
                                {p.Type === 5 && (
                                    <input
                                        required={mandatory}
                                        type="datetime-local"
                                        defaultValue={formatedToInput(p.Values[0]?.Value)}
                                        disabled={props.disableMode}
                                        onChange={e => onChange(inx, [{ Index: p.Values[0]?.Index, Value: formatDate(new Date(e.target.value)), DisplayValue: formatDate(new Date(e.target.value)) }])}
                                    />
                                )}
                                {p.Type === 3 && (
                                    <div className="mfx-checkbox-element">
                                        <input
                                            type="checkbox"
                                            defaultChecked={p.Values[0]?.Value?.toUpperCase() === 'TRUE' ? true : false}
                                            disabled={props.disableMode}
                                            onChange={e => {
                                                onChange(inx, [{ Index: p.Values[0]?.Index, Value: e.target.checked ? 'TRUE' : 'FALSE', DisplayValue: e.target.checked ? 'TRUE' : 'FALSE' }]);
                                            }}
                                        />
                                        <label style={{ color: props.disableMode || Boolean(props.designData.ReadOnly) ? 'var(--gray)' : 'var(--fontColor)' }}>{p.Name}</label>
                                    </div>
                                )}
                            </div>
                        </>
                    );
                })}
        </>
    );
};

export default Profiling;
